import { render, staticRenderFns } from "./FormPointOfInterest.vue?vue&type=template&id=4f9c8f2c&scoped=true"
import script from "./FormPointOfInterest.vue?vue&type=script&lang=js"
export * from "./FormPointOfInterest.vue?vue&type=script&lang=js"
import style0 from "./FormPointOfInterest.vue?vue&type=style&index=0&id=4f9c8f2c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f9c8f2c",
  null
  
)

export default component.exports